import { useCallback, useEffect, useRef } from "react";

/**
 * A hook used to check if the component is still mounted
 * before making state changes.
 * https://usehooks-ts.com/react-hook/use-is-mounted
 */
function useIsMounted(): () => boolean {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
}

export default useIsMounted;
